export enum CmdType {
  sendcaptchaexpress = 'SENDCAPTCHAEXPRESS', // 인증번호 요청
  sendotpverfy = 'SENDOTPVERFY', // 가입 요청
}
export enum Telecom {
  SKT = 0,
  KT = 1,
  LGUP = 2
}

export const SERVER_URL = process.env.REACT_APP_REST_API_URL || ''
export const IMG_SERVER_URL = process.env.REACT_APP_IMAGE_SERVER_URL || ''

export default CmdType;
